import React, { useState } from "react";
import { useControlContext } from "../context";
import { Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCashRegister } from "@fortawesome/free-solid-svg-icons";
import SelectPaymentMethod from "./SelectPaymentMethod";
import CardResume from "./CardResume";

function FormPaymentMethod(props) {
  const [showResumo, setShowResumo] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const { setProgressViewerPayment, setActiveFormPaymentMethod } = useControlContext();

  const { handleNext, active } = props;

  const handleSelect = (eventKey) => {
    setPaymentMethod(eventKey);
    setShowResumo(true);
    handleNext();
    setProgressViewerPayment(true);
  };

  const edit = () => {
    setActiveFormPaymentMethod(true);
    setShowResumo(false);
  };

  return (
    <>
      <Card hidden={!active || showResumo} border="primary">
        <Card.Body>
          <Card.Subtitle>
            <FontAwesomeIcon icon={faCashRegister} color="#0d6efd" /> Forma de
            Pagamento
          </Card.Subtitle>
          <p className="mb-1">Selecione a forma de pagamento</p>

          <SelectPaymentMethod handleSelect={handleSelect} />
        </Card.Body>
      </Card>
      <CardResume
        show={showResumo}
        handleEdit={edit}
        title="Forma de Pagamento"
        icon={faCashRegister}
      >
        Será pago com: {paymentMethod}
      </CardResume>
    </>
  );
}

export default FormPaymentMethod;
